/* global $ */

export default async function (emailValidationData) {
  const { $form, source, emailInputId } = emailValidationData;

  const emailInput = $form.find(`#${emailInputId}`);
  if (emailInput.is(":hidden")) {
    $form.find("#id_email_is_validated").val("skip");
    $form.trigger("submit");
    return true;
  }

  $("body").addClass("overlay");
  $(".js-email_overlay").removeClass("hidden").addClass("verifying_email");
  const csrfmiddlewaretoken = $form.find('[name=csrfmiddlewaretoken]').val();
  const email = emailInput.val();

  return fetch("/email_validation/api/verify-email/", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Referer": window.location.href,
      "X-CSRFToken": csrfmiddlewaretoken,
    },
    body: JSON.stringify({
      email: email,
      source: source || "",
      csrfmiddlewaretoken: csrfmiddlewaretoken,
    })
  }).then(response => {
    if (response.ok) {
      return response.json();
    } else if (response.status !== 503) {
      throw new Error("An internal error occurred while verifying the email address. Please try again later.");
    }
  }).then(async data => {
    if (!data) {
      return false;
    }

    const validator = $form.validate();

    if (data.verdict === "Invalid") {
      const emailFieldName = $form.find(`#${emailInputId}`).attr('name');
      validator.showErrors({
        [emailFieldName]: data.message,
      });

      $("body").removeClass("overlay");
      document.getElementById(emailInputId).scrollIntoView({ behavior: "smooth", block: "center" });
      $(".js-qas-submit").prop("disabled", false);
      $(".js-email_overlay").addClass("hidden");
      return false;

    } else if (data.verdict === "Prompt") {
      $("#email_processing").hide();
      $("#email_prompt").show();
      $("#email-entered").html(email);
      if (data.suggested_edits && data.suggested_edits.length) {
        if (!data.allow_original) {
          $(".js-use_email").addClass("hidden");
        }
        const suggestedEmail = data.suggested_edits;
        $(".prompt_box__suggestion").removeClass("hidden");
        $(".prompt_box").addClass("has-suggestions");
        $("#email-suggestion").text(suggestedEmail);
      }

      // Wait for the User to make a selection.
      const proceedToSubmit = await new Promise(function (resolve) {
        $(document).off("click", ".js-email_option").on("click", ".js-email_option", function (ev) {
          $(".js-email_option").unbind();

          if ($(ev.currentTarget).hasClass("js-edit_email")) {
            // Return to Form so the user can make edits.
            // We want to skip adding the validation token since the form isn't being submitted yet.
            reset_email_form();
            $(".js-qas-submit").prop("disabled", false);
            // Make sure the "Validating Email Address" popup is ready to be visible next time.
            $("#email_processing").show();
            $(".js-email_overlay").removeClass("verifying_email").addClass("hidden");
            document.getElementById(emailInputId).scrollIntoView({ behavior: "smooth", block: "center" });
            resolve(false);

          } else if ($(ev.currentTarget).hasClass("js-use_email")) {
            // Use the email as entered (NOT validated).
            $form.find("#id_email_is_validated").val("false");
            resolve(true);

          } else {
            // Use corrected email.
            $form.find(`#${emailInputId}`).val(data.suggested_edits);
            $form.find("#id_email_is_validated").val("true");
            resolve(true);
          }
        });
      });

      reset_email_form();

      return proceedToSubmit;

    } else {
      // We don't want to penalize users because we couldn't reach Sendgrid, but indicate the email wasn't validated.
      $form.find("#id_email_is_validated").val(data.error ? "false" : "true");
      return true;
    }
  }).then(shouldSubmit => {
    if (shouldSubmit) {
      $form.trigger("submit");
      return true;
    } else {
      return false;
    }

  }).catch(err => {
    const p = $(`<p class="alert alert-error">${err.message}</p>`);
    const div = $(`<div class="login wrapper"></div>`).append(p);
    $form.before(div);
    $("#email_processing").hide();
    $("body").removeClass("overlay");
    return false;
  });
}


function reset_email_form() {
  $(".prompt_box").removeClass("has-suggestions");
  $(".prompt_box__suggestion").addClass("hidden");
  $(".js-use_email").removeClass("hidden");
  $("#email-suggestion").text("");
  $("#email_prompt").hide();
  $("body").removeClass("overlay");
}
